<template>
  <v-card class="mr-3 ml-3 mb-3">
<!--    <v-card-title class="headline">-->
<!--      &lt;!&ndash;      <span class="mr-3">История Входов/Выходов</span>&ndash;&gt;-->
<!--      <v-btn-->
<!--          color="green"-->
<!--          dark-->
<!--          @click="periodDialog = true"-->
<!--      >-->
<!--        <span>Выбрать период</span>-->
<!--      </v-btn>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-text-field-->
<!--          v-if="logs"-->
<!--          v-model="search"-->
<!--          append-icon="mdi-magnify"-->
<!--          label="Поиск"-->
<!--          single-line-->
<!--          hide-details-->
<!--      ></v-text-field>-->
<!--    </v-card-title>-->
    <v-card-title class="headline justify-space-between">
      <div>
        <v-btn
            color="green"
            dark
            @click="periodDialog = true"
        >
          <span>Выбрать период</span>
        </v-btn>
      </div>

      <div>
        <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
        ></v-text-field>
      </div>
    </v-card-title>

    <v-data-table class="mb-3 mx-3"
                  :search="search"
                  :headers="headers"
                  :items="logsFiltered"
                  sort-by="id"
                  sort-desc
                  no-data-text="Пусто"
                  no-results-text="Результатов нет"
                  hide-default-footer
                  :loading="tableLoading"
                  loading-text="Загрузка"
                  :custom-sort="customSort"
                  :items-per-page="10"
    >
      <template v-slot:item.userFullName="{ item }">
        <span class="clickable-item"
              @click="$router.push(`/users/${item.userId}`)"
        >{{ item.userFullName }}</span>
      </template>
      <template v-slot:item.dealerName="{ item }">
        <span class="clickable-item"
              @click="$router.push(`/dealers/${item.dealerId}`)"
        >{{ item.dealerName }}</span>
      </template>
      <template v-slot:item.datetime="{ item }">
        {{ new Date(item.datetime).toLocaleDateString() + ' ' + new Date(item.datetime).toLocaleTimeString() }}
      </template>
      <template v-slot:item.ipInfo="{ item }">
        <span v-html="item.ipInfo"></span>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"/>
      </template>
    </v-data-table>

    <v-dialog v-model="periodDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Выбрать период построения отчета</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="d-flex justify-space-between flex-wrap">
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setTodayFilter"
                >Сегодня
                </v-btn>
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setWeekFilter"
                >Неделя
                </v-btn>
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setMonthFilter"
                >Месяц
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dateFromFormatted"
                      label="Начало периода"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateFromFormatted)"
                      v-on="on"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom"
                               no-title
                               @input="dateFromMenu = false"
                               :max="getIsoDate(new Date())"
                               :first-day-of-week="1"
                               locale="ru-RU"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dateToFormatted"
                      label="Конец периода"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateToFormatted)"
                      v-on="on"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateTo"
                               no-title
                               @input="dateToMenu = false"
                               :max="getDateToMax()"
                               :first-day-of-week="1"
                               locale="ru-RU"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="filterLogs">Применить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  data() {
    return {
      periodDialog: false,

      dateFromMenu: false,
      dateFrom: null,
      dateFromFormatted: '',

      dateToFormatted: '',
      dateTo: null,
      dateToMenu: false,

      tableLoading: true,
      search: '',
      logs: [],
      logsFiltered: [],
      headers: [
        {
          text: '#',
          align: 'start',
          value: 'id',
        },
        {
          text: 'Пользователь',
          align: 'start',
          value: 'userFullName',
        },
        {
          text: 'Дилер',
          align: 'start',
          value: 'dealerName',
        },
        {
          text: 'IP',
          align: 'start',
          value: 'ipInfo',
        },
        {
          text: 'Дата/Время',
          align: 'start',
          value: 'datetime',
        },
        {
          text: 'Источник',
          align: 'center',
          value: 'source',
        },
      ],
    }
  },
  watch: {
    dateFrom() {
      this.dateFromFormatted = this.formatDate(this.dateFrom);
    },
    dateTo() {
      this.dateToFormatted = this.formatDate(this.dateTo);
    },
    dateFromFormatted() {
      this.dateFrom = this.parseDate(this.dateFromFormatted);
    },
    dateToFormatted() {
      this.dateTo = this.parseDate(this.dateToFormatted);
    },
  },
  methods: {
    customSort(items, index, isDesc) {
      if (index[0] === "datetime") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.datetime) > new Date(b.datetime) ? 1 : -1;
          } else {
            return new Date(a.datetime) > new Date(b.datetime) ? -1 : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    setTodayFilter() {
      this.dateFrom = this.getIsoDate(new Date());
      this.dateTo = this.getIsoDate(new Date());
    },
    setWeekFilter() {
      this.dateFrom = this.getIsoDate(new Date(new Date().setDate(new Date().getDate() - 7)));
      this.dateTo = this.getIsoDate(new Date());
    },
    setMonthFilter() {
      this.dateFrom = this.getIsoDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
      this.dateTo = this.getIsoDate(new Date());
    },
    filterLogs() {
      if (!this.dateFrom || !this.dateTo) {
        this.$store.commit('showSnackbar', {
          color: 'warning',
          text: 'Выберите даты начала и конца периода',
        });
        return;
      }

      const dateFrom = new Date(`${this.dateFrom}T00:00:00`);
      const dateTo = new Date(`${this.dateTo}T23:59:59`);

      if (dateTo < dateFrom) {
        this.$store.commit('showSnackbar', {
          color: 'warning',
          text: 'Дата окончания не может быть раньше даты начала',
        });
        return;
      }

      const maxDateTo = new Date(dateFrom);
      maxDateTo.setMonth(maxDateTo.getMonth() + 3);

      if (dateTo > maxDateTo) {
        this.$store.commit('showSnackbar', {
          color: 'warning',
          text: 'Промежуток не должен превышать 3 месяца',
        });
        return;
      }

      this.periodDialog = false;
      this.getLogs(true);
    },
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    getDateToMax() {
      const today = new Date();

      if (!this.dateFrom) {
        return this.getIsoDate(today);
      }

      const maxDateFromPeriod = new Date(`${this.dateFrom}T00:00:00`);
      maxDateFromPeriod.setMonth(maxDateFromPeriod.getMonth() + 3);

      return this.getIsoDate(maxDateFromPeriod < today ? maxDateFromPeriod : today);
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editLicense(license) {
      this.$router.push('/licenses/' + license.id)
    },
    async getLogs(withPeriod = false) {
      this.tableLoading = true;

      const params = withPeriod && this.dateFrom && this.dateTo
          ? {
            date_from: this.dateFrom,
            date_to: this.dateTo,
          }
          : {};

      await API.get('reports/users/logins', {params})
          .then((response) => {
            console.log(response.data);
            this.logs = response.data.logs;
            this.logsFiltered = response.data.logs;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.tableLoading = false;
          });
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'reports', disabled: true},
      {text: 'users', disabled: true},
      {text: 'logins', disabled: true},
    ]);
    this.getLogs();
  },
  created() {
    this.setWeekFilter();
  }
}
</script>

<style>
.clickable-item {
  background-color: #d5e9d4;
  padding: .2rem .5rem;
  border-radius: 5px;
  cursor: pointer;
}
</style>
